<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col text-center">
        <h1>Πολιτική για τα Ηλεκτρονικά Μπισκότα (Cookies)</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <h4>Πληροφορίες για τα cookies</h4>
        <p>
          Χρησιμοποιούμε cookies στην ιστοσελίδα μας για την ορθή λειτουργία της, για την παροχή προσωποποιημένων λειτουργιών, για την βελτίωση και την προσαρμογή διαφημιστικού και
          άλλου περιεχομένου ούτως ώστε να ανταποκρίνεται στις ιδιαίτερες ανάγκες και ενδιαφέροντά σας. Επίσης χρησιμοποιούμε cookies για να συγκεντρώσουμε στατιστικά στοιχεία που
          μας επιτρέπουν να αντιληφθούμε πώς οι χρήστες χρησιμοποιούν την ιστοσελίδα μας και για να βελτιώσουμε τη δομή και το περιεχόμενό της.
        </p>
        <ol>
          <li>
            Τι είναι τα cookies;
            <p>
              Τα cookies είναι μικρά αρχεία κειμένου που περιέχουν πληροφορίες πλοήγησης και αποθηκεύονται στον υπολογιστή, στο κινητό ή σε οποιαδήποτε άλλη ηλεκτρονική συσκευή
              σας, όταν επισκέπτεστε μια ιστοσελίδα. Με τα cookies συντηρούνται για κάποιο χρονικό διάστημα οι ενέργειες και οι προτιμήσεις σου, όπως η γλώσσα, το μέγεθος
              γραμματοσειράς ή άλλες προτιμήσεις απεικόνισης. Έτσι δεν χρειάζεται να καταχωρείτε τις προτιμήσεις αυτές κάθε φορά που επισκέπτεστε ένα site και πλοηγήστε στις
              σελίδες του. Επιπλέον, τα cookies μας βοηθούν να αναλύουμε πώς χρησιμοποιείτε την ιστοσελίδα μας και εάν αντιμετωπίζετε προβλήματα κατά την περιήγησή σας. Επίσης μας
              επιτρέπουν την προσαρμογή των online εμφανιζόμενων διαφημίσεων και προσφορών στα ενδιαφέροντα και τις ανάγκες σας.
            </p>
          </li>
          <li>
            Πως διαχωρίζονται τα cookies;
            <p>
              Τα cookies αρχικά χωρίζονται ανάλογα με τη διάρκειά τους. Υπάρχουν τα «προσωρινά» (session cookies) που απαλείφονται αυτομάτως όταν κλείσετε το browser σας και τα
              «μόνιμα» (persistent cookies) τα οποία παραμένουν αποθηκευμένα για ορισμένη χρονική διάρκεια.
            </p>
          </li>
          <li>
            Πως μπορώ να αποδεχτώ την εγκατάσταση των cookies;
            <p>
              Με την είσοδό σας στην ιστοσελίδα ενημερώνεστε με εμφανή καταχώρηση για την χρήση cookies. Για συγκεκριμένους τύπους cookies θα χρειαστούμε την συγκατάθεσή σας.
              Μπορείτε να τροποποιήσετε ή να ανακαλέσετε την συγκατάθεσή σας ανά πάσα στιγμή.
            </p>
          </li>
          <li>
            Πως μπορώ να διαγράψω τα cookies;
            <p>
              Μπορείτε να διαγράψετε τα cookies και να απενεργοποιήσετε τη χρήση τους. Επιλέξτε τον browser που χρησιμοποιείτε και ακολουθήστε τις οδηγίες:
            </p>
            <ul>
              <li>
                <a target="_blank" href="https://support.google.com/chrome/answer/95647?hl=el">Chrome</a>
              </li>
              <li>
                <a target="_blank" href="https://support.mozilla.org/el/kb/pws-energopoiw-th-leitoyrgia-do-not-track">Firefox</a>
              </li>
              <li>
                <a target="_blank" href="https://support.apple.com/kb/PH19214?locale=el_GR&viewlocale=el_GR">Safari</a>
              </li>
            </ul>
            <p>Εάν χρησιμοποιείτε κάποιον άλλον browser, συμβουλευτείτε τις πληροφορίες του παρόχου.</p>
          </li>
        </ol>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <h4>Cookies αναγκαία και λειτουργικότητας</h4>
        <p>
          Τα cookies αυτά είναι τεχνικά απαραίτητα για την πραγματοποίηση της σύνδεσης στον ιστότοπο ή για την παροχή της υπηρεσίας διαδικτύου την οποία έχετε ζητήσει. Σε αυτήν την
          κατηγορία ανήκουν cookies που χρησιμοποιούνται για την αναγνώριση ή/και διατήρηση περιεχομένου που εισάγει ο συνδρομητής ή χρήστης κατά τη διάρκεια μιας σύνδεσης
          (session) σε ιστότοπο καθ’ όλη τη διάρκεια της συγκεκριμένης σύνδεσης, όπως το «καλάθι αγορών», για τη σύνδεση του συνδρομητή ή χρήστη σε υπηρεσίες που απαιτούν
          αυθεντικοποίηση, για την ασφάλεια του χρήστη, για την πραγματοποίηση της τεχνικής της κατανομής φορτίου (load balancing) σε μία σύνδεση σε ιστοσελίδα του διαδικτύου, για
          την επίλυση των τεχνικών σφαλμάτων της ιστοσελίδας, για τη διατήρηση των επιλογών του χρήστη σχετικά με την παρουσίαση του ιστότοπου, π.χ. επιλογή γλώσσας.
          Τα cookies αυτής της κατηγορίας δεν μπορούν να απενεργοποιηθούν. Εάν ρυθμίσετε τον browser σας, ώστε να μπλοκάρει τη χρήση αυτών των cookies η ιστοσελίδα ή
          ορισμένα τμήματα αυτής δεν θα λειτουργούν.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <h4>Cookies Επιδόσεων</h4>
        <p>
          Αυτά τα cookies συλλέγουν πληροφορίες σχετικά με τον τρόπο που οι επισκέπτες χρησιμοποιούν την ιστοσελίδα, για παράδειγμα πόσοι χρήστες την επισκέφτηκαν, ποιες επιμέρους
          σελίδες επισκέπτονται συχνότερα κτλ. Αυτά τα cookies συλλέγουν συγκεντρωτικές πληροφορίες που δεν ταυτοποιούν άμεσα κάποιον χρήστη και χρησιμοποιούνται αποκλειστικά για
          τη βελτίωση της λειτουργίας της ιστοσελίδας.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <h4>Cookies στόχευσης/διαφήμισης</h4>
        <p>
          Αυτά τα cookies χρησιμοποιούνται για την παροχή περιεχομένου, που ταιριάζει περισσότερο σε εσάς και τα ενδιαφέροντά σας. Μπορεί να χρησιμοποιηθούν για την αποστολή
          στοχευμένης διαφήμισης/προσφορών, τον περιορισμό προβολών διαφήμισης ή την μέτρηση της αποτελεσματικότητας μιας διαφημιστικής καμπάνιας. Επίσης, μπορεί να χρησιμοποιηθούν
          για να θυμόμαστε μέσω ποιου ιστότοπου πληροφορηθήκατε για την ιστοσελίδα μας, ώστε να καθορίσουμε τα αποτελεσματικότερα ηλεκτρονικά κανάλια μάρκετινγκ. Τα cookies αυτά
          σας αναγνωρίζουν με τεχνικά δεδομένα, όπως η IP διεύθυνσή σας, το πρόγραμμα περιήγησής σας και ο τύπος της συσκευής σας.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <h4>Cookies βελτιστοποίησης εμπειρίας</h4>
        <p>
          Αυτά τα cookies επιτρέπουν στην ιστοσελίδα να θυμάται τις πληροφορίες που έχετε εισάγει σε συγκεκριμένα πεδία της (π.χ. στοιχεία του οχήματος, ημερομηνία λήψης της άδειας
          οδήγησης, Ταχυδρομικός Κωδικός κατοικίας), προκειμένου για τη λήψη προσφοράς ασφάλισης ή την υποβολή αίτησης ασφάλισης. Έτσι, δεν θα χρειαστεί να εισάγετε ξανά τις
          συγκεκριμένες καταχωρήσεις κατά τη διάρκεια της περαιτέρω - αλλά και βραχυπρόθεσμα μελλοντικής - πλοήγησής σας στην ιστοσελίδα, για να λάβετε προσφορά ασφάλισης ή για να
          προχωρήσετε σε σύναψη ασφαλιστηρίου. Τα σχετικά πεδία θα εμφανίζονται προσυμπληρωμένα βάσει των αρχικών καταχωρήσεών σας, οπότε βελτιώνεται η ευκολία και ταχύτητα της
          πλοήγησης άρα και η εμπειρία σας.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 form-group">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <span><on-off-switch v-model="cookies.necessary" :disabled="true" /></span>
              <span class="ml-2">
                <strong>Απαραίτητα:</strong> Είναι απολύτως απαραίτητα για την σωστή λειτουργία της ιστοσελίδας και επιτρέπουν στον επισκέπτη να κάνει περιήγηση και να χρησιμοποιεί τις υπηρεσίες της.
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 form-group">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <span><on-off-switch v-model="cookies.performance" /></span>
              <span class="ml-2">
                <strong>Επίδοσης:</strong> Bοηθούν στο να κατανοήσουμε πώς αλληλεπιδρούν οι επισκέπτες με τις σελίδες συλλέγοντας συγκεντρωτικές πληροφορίες που δεν ταυτοποιούν άμεσα κάποιον επισκέπτη.
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 form-group">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <span><on-off-switch v-model="cookies.marketing" /></span>
              <span class="ml-2">
                <strong>Στόχευσης/διαφήμισης:</strong> Χρησιμοποιούνται για την παροχή προσωποποιημένου περιεχομένου στον επισκέπτη και τη διενέργεια ή τον έλεγχο στοχευμένης διαφημιστικής καμπάνιας.
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 form-group">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <span><on-off-switch v-model="cookies.preferences" /></span>
              <span class="ml-2">
                <strong>Βελτιστοποιήση εμπειρίας:</strong> Επιτρέπουν στην ιστοσελίδα να ανακαλεί πληροφορίες που έχει συμπληρώσει ο επισκέπτης σε πεδία, προκειμένου να διευκολύνει την πλοήγησή του.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-8 d-md-flex flex-row">
        <button type="button" class="btn btn-primary btn-block" @click="savecookies">Αποθήκευση αλλαγών</button>
        <button type="button" class="btn btn-primary btn-block mt-0 mx-2" @click="rejectCookies">Απόρριψη cookies</button>
        <button type="button" class="btn btn-primary btn-block mt-0" @click="acceptCookies">Αποδοχή ολων των cookies</button>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { bootstrap, setOptions } from 'vue-gtag';

export default {
  created() {
    const cookie = Cookies.get('cos_ins_cookie');
    if (!cookie) return;
    const cookieArray = Array.from(cookie);
    this.cookies.performance = !!Number(cookieArray[1]);
    this.cookies.marketing = !!Number(cookieArray[2]);
    this.cookies.preferences = !!Number(cookieArray[3]);
  },
  data() {
    return {
      cookies: {
        necessary: true,
        performance: true,
        marketing: true,
        preferences: true
      }
    };
  },
  methods: {
    savecookies() {
      const cookie = Cookies.get('cos_ins_cookie') || '1000';
      const cookieArray = Array.from(cookie);

      cookieArray[1] = this.cookies.performance ? '1' : '0';
      cookieArray[2] = this.cookies.marketing ? '1' : '0';
      cookieArray[3] = this.cookies.preferences ? '1' : '0';
      Cookies.set('cos_ins_cookie', cookieArray.join(''));
      if (cookieArray[1] === '1') {
        this.initAnalytics();
      }
      if (cookieArray[1] === '0') {
        this.disableAnalytics();
      }
    },
    rejectCookies() {
      Cookies.set('cos_ins_cookie', '1000');
      this.cookies.performance = false;
      this.cookies.marketing = false;
      this.cookies.preferences = false;
      this.disableAnalytics();
    },
    acceptCookies() {
      Cookies.set('cos_ins_cookie', '1111');
      this.cookies.performance = true;
      this.cookies.marketing = true;
      this.cookies.preferences = true;
      this.initAnalytics();
    },
    initAnalytics() {
      bootstrap().then(() => {
        // console.log(gtag);
        // gtag('event', 'search', {
        //   search_term: 't-shirts'
        // });
        // all done!
      });
      window['ga-disable-G-JSPTB2H75F'] = false;
      setOptions({
        enabled: true
      });
    },
    disableAnalytics() {
      setOptions({
        enabled: false
      });
      window['ga-disable-G-JSPTB2H75F'] = true;
    }
  }
};
</script>
